export default "__VITE_ASSET__DyXq9DU$__"